import { createQueryKeys } from "@lukemorales/query-key-factory";
import { ConfigurationTemplateApi } from "mws-framethegame-ts-sdk";

import { getUniversalAxios } from "~/utils/axios/getUniversalAxios";

const getConfigurationTemplatesApi = () => {
  return new ConfigurationTemplateApi(
    undefined,
    useRuntimeConfig().public.ftgServiceUrl,
    getUniversalAxios(),
  );
};

export const presetsQueryKeys = createQueryKeys("presets", {
  list: (productId: MaybeRef<string>) => ({
    queryKey: [productId],
    queryFn: async () => {
      const response = await getConfigurationTemplatesApi().presetsGet({
        frameableProductExternalId: unref(productId),
      });

      return response.data;
    },
  }),
});
